export const TOGGLE_QUICKVIEW = 'TOGGLE_QUICKVIEW';
export const HISTORY_PREV_ITEM = 'HISTORY_PREV_ITEM';
export const SAVE_SCROLL_POSITION = 'SAVE_SCROLL_POSITION';
export const SET_ADDITIONAL_PARAMS = 'SET_ADDITIONAL_PARAMS';

// App
export const APP_QUICKVIEW_REQUEST = 'APP_QUICKVIEW_REQUEST';
export const APP_QUICKVIEW_SUCCESS = 'APP_QUICKVIEW_SUCCESS';
export const APP_QUICKVIEW_FAILURE = 'APP_QUICKVIEW_FAILURE';

// App Details
export const DETAILS_APP_QUICKVIEW_REQUEST = 'DETAILS_APP_QUICKVIEW_REQUEST';
export const DETAILS_APP_QUICKVIEW_SUCCESS = 'DETAILS_APP_QUICKVIEW_SUCCESS';
export const DETAILS_APP_QUICKVIEW_FAILURE = 'DETAILS_APP_QUICKVIEW_FAILURE';

// Pub
export const PUB_QUICKVIEW_REQUEST = 'PUB_QUICKVIEW_REQUEST';
export const PUB_QUICKVIEW_SUCCESS = 'PUB_QUICKVIEW_SUCCESS';
export const PUB_QUICKVIEW_FAILURE = 'PUB_QUICKVIEW_FAILURE';
export const PUB_QUICKVIEW_SALESFORCE_UPDATE = 'PUB_QUICKVIEW_SALESFORCE_UPDATE';

// Company
export const COMPANY_QUICKVIEW_REQUEST = 'COMPANY_QUICKVIEW_REQUEST';
export const COMPANY_QUICKVIEW_SUCCESS = 'COMPANY_QUICKVIEW_SUCCESS';
export const COMPANY_QUICKVIEW_FAILURE = 'COMPANY_QUICKVIEW_FAILURE';

export const CANCEL_REQUEST = 'CANCEL_REQUEST';
